module.exports = __webpack_public_path__ + "img/hacken-logo-icon.891a2ed9.png";